export default "__VITE_ASSET__DDp8Rue$__"